module.exports = __webpack_public_path__ + "fonts/NunitoSans-SemiBold.c334f25.woff2";